import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
import { FloatingLabel } from './FloatingLabel';

const TimePicker = forwardRef(({ size, label, name, error, ...props }, ref) => (
    <Form.Group controlId={name}>
        <FloatingLabel controlId={name} label={label} size={size}>
            <Form.Control
                className="time-picker"
                type="time"
                name={name}
                placeholder={label}
                ref={ref}
                isInvalid={!!error}
                {...props}
            />
            {error && (
                <Form.Control.Feedback type="invalid">
                    {error?.message}
                </Form.Control.Feedback>
            )}
        </FloatingLabel>
    </Form.Group>
));

TimePicker.displayName = 'TimePicker'
export default TimePicker;
